import { useEffect } from "react";

import { useLocation } from "react-router-dom";

export const useScrollToLocationHash = (): void => {
    const { hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            return;
        }
        const anchor = hash.slice(1);
        document.getElementById(anchor)?.scrollIntoView({ behavior: "smooth" });
    }, [hash]);
};
